import { NodeExtension, ParamType } from 'helicon';

export const EuclideanRhythmExtension: NodeExtension = {
  type: 'EuclideanRhythm',
  processor: '/EuclideanRhythmProcessor.js',
  description: {
    numberOfInputs: 0,
    numberOfOutputs: 1,
    outputChannelCount: [1],
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete',
    params: {
      clock: {
        type: ParamType.AudioParam,
        default: 0,
      },
      reset: {
        type: ParamType.AudioParam,
        default: 0,
      },
      length: {
        type: ParamType.AudioParam,
        default: 0,
        min: 0,
        max: 99,
      },
      pulses: {
        type: ParamType.AudioParam,
        default: 0,
        min: 0,
        max: 99,
      },
      rotation: {
        type: ParamType.AudioParam,
        default: 0,
        min: 0,
        max: 99,
      },
    },
    signals: {
      position: {
        readable: true,
        trigger: true,
        default: 0,
      },
      rotation: {
        readable: true,
        trigger: false,
        default: 0,
      },
      sequence: {
        readable: true,
        trigger: false,
        default: [],
      },
    },
  },
};
